import React, { useEffect } from 'react';
import "../../Component/NavBar/Header.css"
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
// Logo
import Logo from "../../Images/Logo.png";
import { Link } from 'react-router-dom';
// social icons 
import { AiFillInstagram } from "react-icons/ai";
import { TiSocialFacebook } from "react-icons/ti";
import { IoIosMail } from "react-icons/io";
import { IoIosCall } from "react-icons/io";
import { FaUser } from "react-icons/fa6";
import { getProfile, getToken } from '../../services/localStorageServices';
import { useDispatch, useSelector } from 'react-redux';
import { setUserToken } from '../../features/authSlice';
const Header = () => {
    const dispatch = useDispatch();
    const { access_token } = getToken();
    const { profile } = getProfile();
    const { token } = useSelector((state) => state.auth);

    useEffect(() => {
        dispatch(setUserToken({ token: access_token }));
    }, [access_token, dispatch]);
    return (
        <>
            <Navbar collapseOnSelect expand="lg">
                <Container>
                    <Navbar.Brand href="/">
                        <Link to="/">
                            <div className='Logo-Con'>
                                <img src={Logo} alt="" />
                            </div>
                        </Link>
                    </Navbar.Brand>
                    <Navbar.Toggle aria-controls="navbarScroll" />
                    <Navbar.Collapse id="responsive-navbar-nav">
                        <Nav
                            className="my-2 my-lg-0"
                            style={{ maxHeight: '100px' }}
                            navbarScroll
                        >
                            <Nav.Link href="/"><Link to="/">Home</Link></Nav.Link>
                            <Nav.Link href="/about"><Link to="/about">About Us</Link></Nav.Link>
                            <Nav.Link href="/Delisted"><Link to="/Delisted">Delisted Shares</Link></Nav.Link>
                            <Nav.Link href="/Unlisted"><Link to="/Unlisted">Unlisted Shares</Link></Nav.Link>
                            <Nav.Link href="/preipo"><Link to="/preipo">Pre IPO/ESOP Shares</Link></Nav.Link>
                            <Nav.Link href="/new-arrival"><Link to="/new-arrival">New Arrival</Link></Nav.Link>
                            <Nav.Link href="/contact"><Link to="/contact">Contact us</Link></Nav.Link>
                        </Nav>
                        <Nav>
                            {/* <div className='social-media-links-con'>
                                <div className='social-media-links'>
                                    <a href='' target='blank'>
                                        <AiFillInstagram />
                                    </a>
                                    <a href='' target='blank'>
                                        <TiSocialFacebook />
                                    </a>
                                    <a href="" target='blank'>
                                        <IoIosMail />
                                    </a>
                                    <a href="">
                                        <IoIosCall />
                                    </a>
                                </div>
                            </div> */}
                            {/* <div className='header-login-register-con'>
                                <div className='header-login-btn'>
                                    <Link to="/account/sign-in">
                                        <button>
                                            Login
                                        </button>
                                    </Link>
                                </div>
                                <div className='header-register-btn'>
                                    <Link to="/account/sign-up">
                                        <button>
                                            Register
                                        </button>
                                    </Link>
                                </div>
                            </div> */}
                            {
                                token ? (
                                    <>
                                        <div className='header-profile-main-con'>
                                            <Link to="/profiles">
                                                <div className='header-profile-con'>
                                                    <FaUser />
                                                    <h3>Siddhesh</h3>
                                                </div>
                                            </Link>
                                        </div>
                                    </>
                                ) : (
                                    <>
                                    <div className='header-navbar-section-login-register-main-con'>
                                        <div className='header-profile-main-con'>
                                            <Link to="/account/sign-in">
                                                <div className='header-profile-con'>
                                                    <FaUser />
                                                    <h3>Login</h3>
                                                </div>
                                            </Link>
                                        </div>
                                        <div className='header-profile-main-con'>
                                            <Link to="/account/sign-up">
                                                <div className='header-profile-con'>
                                                    <FaUser />
                                                    <h3>Register</h3>
                                                </div>
                                            </Link>
                                        </div>
                                    </div>
                                    </>
                                )
                            }
                        </Nav>
                    </Navbar.Collapse>
                </Container>
            </Navbar>
        </>
    )
}

export default Header